
export default {
    name: 'param-exploration-col',
    components: {},
    props: {
        params_cpn: Object,
    },
    data() {
        return {
            fields: [
				'libelle',  { key: 'actions', label: 'Action.s' }
			],
			perPage: -1,
			currentPage: 1,
            is_empty: false
        }
    },

    watch: {
        
    },

    computed: {

    },

    mounted() {

    },

    methods: {

    }
}